import React, { useEffect } from 'react';
import { Container, Content, Header } from './styles';

const SegurancaInformacao = () => {
  useEffect(() => {
    document.title = 'SEGURANÇA DA INFORMAÇÃO | Portal LGPD';
  }, []);

  return (
    <Container>
      <Header>
        <div className="content-header-policy">
          <div className="logo">Vrio</div>
        </div>
      </Header>
      <Content>
        <div className="content-header">
          <h1>SEGURANÇA DA INFORMAÇÃO</h1>
        </div>

        <div className="policy-question-fix">
          <p>
            O presente Anexo (doravante denominado "Anexo") vincula-se ao
            CONTRATO/OFERTA (doravante denominado “CONTRATO/OFERTA”), sendo
            complementar e parte integrante do mesmo.
          </p>
          <p>
            Salvo disposição em contrário, constante no presente Anexo: (i) os
            termos utilizados neste Anexo, para os quais não esteja estabelecida
            uma definição específica, terão os significados respectivos
            definidos no CONTRATO/OFERTA; e (ii) o termo “parágrafo” será
            entendido como os parágrafos compreendidos no presente Anexo.
          </p>
          <h3>1. INTRODUÇÃO</h3>
          <p>
            Conforme estabelecido no CONTRATO/OFERTA, o Serviço oferecido pelo
            Fornecedor implica que ele mantenha em sua própria infraestrutura os
            dados pessoais recebidos da [DTV/SKY] (doravante denominados
            “Dados”). A este respeito, o Fornecedor reconhece que os Dados
            fornecidos pela [DTV/SKY] no âmbito da prestação do Serviço:
          </p>

          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              paddingLeft: 10,
              marginTop: 0,
            }}
          >
            <li
              style={{
                margin: 10,
              }}
            >
              (a) são de propriedade exclusiva da [DTV/SKY] ou contam com a
              autorização do portador do dado;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (b) possuem um alto valor para [DTV/SKY];
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (c) podem não ser de conhecimento público e ter o caráter de
              informação de sigilo absoluto (seja acerca da perspectiva do
              sigilo comercial, da perspectiva de competição ou de
              confidencialidade, ou até mesmo de qualquer natureza) ou
              encontram-se protegidos pelo sigilo profissional; e
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (d) podem ser objeto de restrições para o seu uso, ou para sua
              exportação para entidades ou sujeitos estrangeiros, em virtude das
              leis e regulamentações aplicáveis vigentes nos países contratantes
              (incluindo, sem limitação, regulamentos sobre dados pessoais).
            </li>
          </ul>
          <p>
            Portanto, o Fornecedor deverá restringir-se às práticas da
            [DTV/SKY], e assumir as obrigações estabelecidas no presente Anexo
            com relação ao uso dos Dados e assegurar que não adotará nenhuma
            ação ou omissão que em termos razoáveis possa (i) colocar em perigo
            a segurança, confidencialidade ou integridade dos Dados, ou até (ii)
            infringir a lei vigente com relação ao uso dos Dados.
          </p>

          <h3>2. ALGUMAS DEFINIÇÕES</h3>
          <p>
            "Dados": refere-se a toda informação em posse ou tutela (por
            qualquer título) da [DTV/SKY], armazenada ou processada pelo
            Fornecedor, ou que esteja à disposição deste no âmbito do serviço.
            Tanto em seu formato original quanto em qualquer outro formato que a
            informação se encontre, seja revisada, redesenhada, manipulada,
            transformada, compilada ou na maneira em que foram geradas pelo o
            uso autorizado da mesma. "Uso Autorizado": refere-se ao Uso dos
            Dados conforme a operação normal necessária para que o Fornecedor
            preste o Serviço e seus efeitos pertinentes, segundo o definido no
            CONTRATO/OFERTA, excluindo-se qualquer outro uso.
          </p>
          <p>
            "Usuário Autorizado": esse termo refere-se a todo indivíduo
            expressamente autorizado pela [DTV/SKY] a utilizar o Serviço.
          </p>
          <p>
            "Usuário dependente do Fornecedor": refere-se a todo empregado
            efetivo em relação de dependência do Fornecedor, ou pessoal
            contratado ou autorizado por ele para prestar o Serviço sob o Uso
            Autorizado, com base nas credenciais de uso e acesso outorgadas pelo
            Fornecedor Provedor.
          </p>
          <p>
            "Uso": refere-se ao processamento, armazenamento, manutenção,
            acesso, recuperação, manipulação, inspeção, exame, observação,
            revisão, modificação, tradução, extração, redação, compêndio,
            resumo, ampliação, descrição, comentário, enumeração, compilação,
            recopilação, incorporação, agrupamento, datação, redesenho, gestão,
            transformação, comunicação, transmissão, distribuição, publicação,
            transferência, divulgação, entrega, envio, dissociação, associação,
            classificação, apresentação, oferecimento, exibição, difusão,
            eliminação, supressão, destruição, descarte, tratamento ou outra
            ação, automatizada ou não, a respeito dos Dados.
          </p>
          <p>
            "Serviço": refere-se ao sistema controlado e operado pelo
            Fornecedor, segundo estipulado no CONTRATO/OFERTA.{' '}
          </p>
          <h3>3. OBRIGAÇÕES GERAIS</h3>
          <p style={{ margin: '10px 0' }}>
            <strong>3.1 Restrições de Uso</strong>
          </p>
          <p>
            O Fornecedor só poderá Usar os Dados unicamente, sob os efeitos do
            Uso Autorizado. Sem prejuízo da generalidade anteriormente citada, o
            Fornecedor compromete-se a não efetuar nenhuma das ações enumeradas
            abaixo, sem obter previamente a autorização por escrito da [DTV/SKY]
            em cada caso em particular:
          </p>

          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              paddingLeft: 10,
              marginTop: 0,
            }}
          >
            <li
              style={{
                margin: 10,
              }}
            >
              i. permitir o Uso dos Dados por parte de terceiros, com exceção
              dos Usuários Autorizados;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              ii. vender, revender, alugar, arrendar, transferir ou outorgar
              licença sobre os Dados de algum modo e sem nenhum efeito;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              iii. exportar ou Usar os Dados fora da infraestrutura tecnológica
              que foi submetida à avaliação pelo processo de avaliação de
              segurança de partes terceiras;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              iv. copiar, duplicar ou reproduzir de qualquer modo, em todo ou em
              parte, e por quaisquer meios o formato dos Dados (exceto pelas
              cópias eletrônicas temporais e efêmeras que resultem fortuita e
              necessariamente do Uso Autorizado, e das operações de realização
              de cópias de segurança relacionadas com o Uso Autorizado);
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              v. exceto as ações realizadas por um Usuário Autorizado, revisar
              ou modificar de algum modo os Dados ou comprometer de outro modo
              sua integridade;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              vi. usar de algum modo o Serviço ou os Dados para obter vendas
              comerciais, ou para requerer, induzir ou concretizar compras,
              alugueis, arrendamentos, outorgamento de licenças ou intercâmbio
              de produtos, mercadorias, bens ou serviços (seja por si mesmo ou
              por meio de terceiros), ou, em definitiva, para qualquer fim
              diverso ao Uso Autorizado;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              vii. usar os Dados em ambientes nos quais os Dados não são
              isolados de outros dados;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              viii. permitir que os Usuários Dependentes do Fornecedor acessem
              às máquinas virtuais da [DTV/SKY];
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              ix. conservar os Dados uma vez findo os Serviços, estando obrigado
              a eliminá-los de seus registros ou destrui-los. Salvo com
              autorização expressa e por escrito da [DTV/SKY], caso em que o
              Fornecedor poderá armazenar os dados com as devidas condições de
              segurança por um período de até dois anos.
            </li>
          </ul>

          <p style={{ margin: '10px 0' }}>
            <strong>3.2 Proteção dos Dados</strong>
          </p>
          <p>
            3.2.1 Programa de Segurança. O Fornecedor deverá implementar um
            programa integral escrito de segurança eletrônica e física da
            informação (doravante, o "Programa de Segurança") desenhado para
            proteger em termos razoáveis a segurança física e eletrônica, a
            confidencialidade e a integridade dos Dados da [DTV/SKY], em
            qualquer formato. O Programa de Segurança deverá ser aplicado em
            todo momento.
          </p>
          <p>
            O referido Programa de Segurança deverá incluir todos os resguardos
            de proteção administrativos, técnicos, físicos e legais em vigor que
            sejam requeridos em virtude tanto da natureza e alcance do Uso
            Autorizado quanto da confidencialidade dos Dados, incluindo os
            seguintes:
          </p>
          <p>
            <strong>A.</strong> designação de um empregado de alto nível
            hierárquico da equipe do Fornecedor aos efeitos da coordenação do
            Programa de Segurança, que por sua vez deverá responder pelo dito
            Programa (doravante, o "Encarregado da Informação");
          </p>

          <p>
            <strong>B.</strong> identificação de riscos internos e externos
            concretos para a segurança, confidencialidade e integridade dos
            Dados que possam decorrer na divulgação, alteração, Uso não
            autorizado, perda, apropriação, destruição ou prejuízo sobre os
            Dados, ou no roubo da identidade ou outro prejuízo, ou inconveniente
            maior para [DTV/SKY], ou para qualquer terceiro. À luz dos riscos
            identificados, o Fornecedor deverá avaliar a idoneidade e
            suficiência dos resguardos previstos e aplicados para mitigação. A
            avaliação de riscos deverá considerar cada área operativa em
            particular, incluindo sem limitação: (1) a seleção, capacitação e
            gestão de pessoal e sua subordinação para convênios de
            confidencialidade escritos; (2) o desenho, desenvolvimento e
            operação de redes e sistemas de informação, incluindo os componentes
            de hardware e software; (3) as práticas aplicadas ao armazenamento,
            transmissão e eliminação de dados; e (4) a prevenção, detecção e
            resposta ante ameaças internas, ataques ou intrometimentos externos,
            ameaças de fraude informática e falhas no software, hardware ou no
            sistema.
          </p>

          <p>
            <strong>C.</strong> desenho e implementação de seguranças que sejam
            razoáveis e congruentes com as boas práticas em vigor na indústria
            para o controle dos riscos identificados através da mencionada
            avaliação de risco (tais como: sistemas de gestão de correção de
            erros, criptografia total e não aprovisionamento, seguro de discos,
            segmentação e tokenização física e virtual de dados e serviços,
            controles à gestão de câmbios, sistemas de prevenção de perda de
            dados e sistemas de gestão de segurança da informação e de eventos),
            e avaliação e monitoramento periódico da efetividade dos controles,
            sistemas e procedimentos chave relativos à segurança dos Dados; e
          </p>

          <p>
            <strong>D.</strong> avaliação e adaptação periódicas (com frequência
            anual como mínimo) do Programa de Segurança em virtude dos
            resultados das avaliações e monitoramentos estabelecidos no
            parágrafo anterior C., implementação de todo câmbio concreto na
            operatória e esquema comercial do Fornecedor e de toda outra
            situação que o Fornecedor acredite ou tenha motivos para crer que
            possa afetar de maneira concreta a efetividade do Programa de
            Segurança, incluindo, sem caráter taxativo, toda modificação nas
            leis e regulamentações relativas à segurança de dados,
            confidencialidade e demais recursos de proteção da informação de
            natureza ou nível de confidencialidade semelhante à contida nos
            Dados (em diante, as "Disposições Legais sobre Proteção de Dados").
          </p>

          <p>
            <strong>E.</strong> [DTV/SKY] irá submeter ao Processo de Avaliação
            de Segurança de Partes Terceiras ao Fornecedor de modo a regular a
            cada 365 dias. O Fornecedor irá completar o formulário de
            autoavaliação e apresentará as evidências solicitadas a cada
            controle de segurança a requerimento da [DTV/SKY]. Cada requerimento
            de documentação implicado nesta avaliação terá um prazo máximo de
            resposta de 5 (cinco) dias úteis.
          </p>

          <p>
            3.2.2 Normas relativas à Proteção de Dados. Sem prejuízo do caráter
            geral do parágrafo 3.2.1., o Fornecedor deverá cumprir com o
            disposto a seguir com relação ao Uso dos Dados:
          </p>

          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              paddingLeft: 10,
              marginTop: 0,
            }}
          >
            <li
              style={{
                margin: 10,
              }}
            >
              (A) Restringir-se à norma ISO/IEC 27002:2013 (Código de Práticas
              aplicáveis à Gestão de Segurança da Informação) em sua versão
              atualmente vigente (em diante as "Normas ISO ISMSs" -ISMS, sigla
              em inglês correspondente a Information Security Management
              System-); e
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (B) cumprir com as políticas de empresas a respeito da gestão da
              informação que atualmente estejam vigentes e que sejam informadas
              para o Fornecedor (em diante as "Políticas de [DTV/SKY]"). (Em seu
              conjunto, as Normas ISO ISMSs e as Políticas de [DTV/SKY]
              constituem as “Normas relativas à Proteção de Dados”).
            </li>
          </ul>

          <p>
            Oportunamente a partir da assinatura do CONTRATO/OFERTA, a [DTV/SKY]
            poderá informar ao Fornecedor outras normas tendentes à proteção da
            segurança, confidencialidade e integridade dos Dados que sejam
            razoavelmente aplicáveis ao Serviço ou para determinados tipos de
            Dados, de acordo com a evolução das boas práticas da indústria (tais
            como normas para a segurança da informação publicadas com
            posterioridade da data do presente documento pela Organização
            Internacional para a padronização e a comissão Eletrotécnica
            Internacional ou o Padrão de Segurança de Dados para a Indústria de
            Cartão de Pagamento, elaborado pelo PCI Security Standards Council),
            e que sejam promulgadas por toda associação comercial ou
            profissional da qual a [DTV/SKY] ou o Fornecedor sejam membros ou
            que conte com a filiação de uma quantidade significativa de
            concorrentes do Fornecedor, ou que seja de ampla aceitação na
            indústria da segurança de dados. O Fornecedor deverá proceder de
            maneira expeditiva ao cumprimento de toda outra norma que em termos
            razoáveis seja aplicável ao Serviço (a que, uma vez cursada a
            notificação escrita para o Fornecedor por parte da [DTV/SKY], irá
            passar a integrar a definição do termo “Normas relativas à Proteção
            de Dados”).
          </p>

          <p>
            Na medida que o Fornecedor processa, transmita e/ou armazena dados
            de titulares de cartões de crédito e/ou status de transação
            relacionados para ou em nome da [DTV/SKY] utilizando os sistemas do
            Fornecedor, deve o Fornecedor provar de modo regular seu cumprimento
            com o Padrão de Segurança de Dados da Indústria de Cartões de
            Pagamento. O Fornecedor deve cumprir com o Padrão de Segurança de
            Dados da Indústria de Cartões de Pagamento aplicável ao Fornecedor
            com base no volume total de transações num período de 12 meses que
            determina o nível de comerciante e os requisitos necessários para a
            validação. O Conselho de Padrões de Segurança para a Indústria de
            Cartões de Pagamento publica e atualiza as suas informações em
            www.pcisecuritystandards.org, incluindo qualquer standard sucessor
            ou site web do mesmo. O Fornecedor deve demonstrar o cumprimento com
            o padrão de acordo com o nível de comerciante antes de levar a cabo
            o fornecimento dos serviços à [DTV/SKY], devendo estabelecer um
            plano para assegurar o cumprimento contínuo em caso de qualquer
            câmbio ou atualização do padrão, e devendo enviar imediatamente uma
            cópia da Declaração de Cumprimento mais recente outorgada pelo
            Fornecedor e uma cópia da documentação da Matriz de Responsabilidade
            mais atualizada do Fornecedor para: g18906@att.com. O Fornecedor
            também deve enviar certificações de cumprimento e documentação da
            Matriz de Responsabilidade de forma anual e imediata após qualquer
            modificação ou atualização do padrão para que possa seguir com o
            fornecimento dos serviços relacionados com cartões de pagamento para
            a [DTV/SKY].
          </p>

          <p>
            3.2.3 Responsabilidade. Sem prejuízo do que precede, o Fornecedor
            reconhece sua responsabilidade pela segurança, confidencialidade e
            integridade de todos os Dados que sejam Usados em virtude do Serviço
            ou que de outro modo se encontre em seu poder ou sob seu controle.
          </p>
          <p style={{ margin: '10px 0' }}>
            <strong>3.3 Cumprimento das Disposições Legais e Normas.</strong>
          </p>
          <p>
            No seu Uso dos Dados, o Fornecedor deverá cumprir com todas as
            Disposições Legais sobre Proteção de Dados bem como com todas as
            Normas relativas à Proteção de Dados. O Fornecedor declara que hoje
            cumpre com (i) todas as Disposições Legais sobre Proteção de Dados,
            enquanto impõem obrigações diretas a cargo do Fornecedor, e (ii) as
            Normas relativas à Proteção de Dados assinalados nas cláusulas (A),
            (B) e (C) do parágrafo 3.2.2. a respeito das operações do Fornecedor
            ou segmentos do Serviço que Usem os Dados.
          </p>
          <p style={{ margin: '10px 0' }}>
            <strong>
              3.4 Incidentes relacionados com a Proteção de Dados.
            </strong>
          </p>

          <p>
            3.4.1 Definição. Entende-se por “Incidente” os listados a seguir:
          </p>

          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              paddingLeft: 10,
              marginTop: 0,
            }}
          >
            <li
              style={{
                margin: 10,
              }}
            >
              (A) todo inadimplemento detectado nas instalações, equipe,
              sistemas ou pessoas contratadas ou empregadas pelo Fornecedor
              (incluindo, sem caráter taxativo, inadimplemento do Serviço)
              (doravante “Inadimplemento”) que em termos razoáveis possa esperar
              que tenha um efeito adverso sobre a segurança, confidencialidade
              ou integridade dos Dados;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (B) toda falta de cumprimento do Programa de Segurança ou das
              Normas relativas à Proteção de Dados;
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (C) toda apropriação de Dados, toda situação que signifique uma
              ameaça a sua segurança ou implique um Uso não autorizado dos
              Dados; ou
            </li>
            <li
              style={{
                margin: 10,
              }}
            >
              (D) toda: (1) reclamação, demanda ou procedimento iniciado por
              terceiros com relação aos Dados, ou (2) indagação, investigação ou
              processo administrativo iniciado ou ordenado por entes
              governamentais ou regulatórios a respeito de um Inadimplemento ou
              violação, por parte do Fornecedor, das Disposições Legais
              relativas à Proteção de Dados.
            </li>
          </ul>

          <p>
            3.4.2 Notificação para [DTV/SKY]. No momento em que tomar
            conhecimento de um Incidente, o Fornecedor deverá notificar a
            [DTV/SKY], por escrito e de maneira expositiva (dentro de um prazo,
            que em nenhum caso poderá ultrapassar o tempo de uma (1) hora para
            os casos descritos nas cláusulas (A) a (C) do parágrafo 3.4.1. e 48
            (quarenta e oito) horas úteis nos outros casos), detalhando as
            circunstâncias e particularidades do caso. Dentro das vinte e quatro
            (24) horas da recepção da referida notificação, o Fornecedor deverá
            fornecer para [DTV/SKY] uma cópia de toda comunicação escrita
            emanada de entes governamentais ou regulatórios e de toda demanda ou
            petição apresentada ante a justiça ou ante aos entes governamentais
            ou regulatórios, que tenham relação ou sejam originados pelo
            Incidente.
          </p>
          <p>
            3.4.3 Suporte de atenção. Sem prejuízo das disposições contidas em
            acordos de nível de serviço, acordos de suporte ou arranjos de
            semelhantes características que pudessem existir entre [DTV/SKY] e o
            Fornecedor, em caso que seja produzido um Incidente, o Fornecedor
            colocará à disposição da [DTV/SKY] de maneira prioritária e sem
            custo algum para esta, um empregado de segurança informática de seu
            próprio pessoal, com conhecimento do Incidente, com disponibilidade
            as 24 (vinte e quatro) horas (tanto por telefone quanto por correio
            eletrônico), que deverá: (i) ter dedicação exclusiva para responder
            consultas, (ii) conhecer as iniciativas do Fornecedor para corrigir
            dito Incidente e estar qualificado para agir em nome do Fornecedor
            na coordenação da resposta e iniciativas de correção; e (iii)
            celebrar as atualizações periódicas que possam corresponder segundo
            as circunstâncias do Incidente.
          </p>
          <p>
            3.4.4 Medidas corretivas. No caso de ocorrência de um Incidente, o
            Fornecedor deverá tomar ações corretivas e de reparação que a
            [DTV/SKY] possa de modo razoável solicitar e que sejam habituais
            para as circunstâncias do caso (como por exemplo: cursar
            notificações de inadimplemento aos indivíduos afetados e/ou
            notificar o incidente às autoridades de aplicação).
          </p>
          <p>
            O Fornecedor deverá proceder e reembolsar a [DTV/SKY] da melhor
            maneira cabível para as partes, e por escrito desta (acompanhado do
            correspondente detalhe), os custos e despesas razoáveis incorridos
            pela [DTV/SKY] aos efeitos da implementação de medidas corretivas e
            de reparação adicionais, adotadas como resultado de um Incidente,
            incluindo, sem caráter taxativo, os seguintes: (a) honorários e
            despesas razoáveis de Auditores de Segurança contratados pela
            [DTV/SKY] conforme o estipulado no parágrafo 3.5. aos efeitos de
            realizar as inspeções pertinentes num Incidente relacionado com a
            Proteção de Dados, e (b) toda outra medida que seja requerida adotar
            conforme as Disposições Legais para a Proteção de Dados ou em
            cumprimento de solicitações de entidades governamentais ou
            reguladoras, ou aquelas medidas que sejam habituais para as
            circunstâncias do caso (como por exemplo, mas sem limitação:
            notificações de inadimplemento aos indivíduos afetados e/ou à
            autoridade de aplicação, cancelamento e reabilitação de contas de
            subscritores da [DTV/SKY], CONTRATO/OFERTA de serviços de
            monitoramento de crédito e de seguros de roubo de identidade aos
            indivíduos afetados).
          </p>
          <p>
            3.4.5 Declarações Públicas. O Fornecedor não poderá emitir
            comunicados de imprensa, cursar notificações por escrito para
            indivíduos que sejam afetados ou às autoridades de aplicação ou
            realizar declarações públicas a respeito de um Incidente sem obter
            de forma prévia o consentimento escrito por parte da [DTV/SKY] a
            respeito do formato e/ou conteúdo no momento do anúncio. O
            Fornecedor deverá prestar sua cooperação de boa fé para a [DTV/SKY]
            respondendo, da melhor forma, todas as consultas inerentes aos
            Incidentes.
          </p>
          <p style={{ margin: '10px 0' }}>
            <strong>3.5 Auditoria</strong>
          </p>
          <p>
            O Fornecedor deverá manter os registros auditáveis que permitam
            comprovar o cumprimento de todos os requerimentos contidos no
            presente Anexo. A requerimento da [DTV/SKY], o Fornecedor colocará à
            sua disposição toda aquela informação que, em termos razoáveis, a
            [DTV/SKY] possa exigir a fim de compreender o tipo e a natureza dos
            Usos dos Dados ou de toda outra atividade realizada pelo Fornecedor.
            O Fornecedor deverá autorizar o Encarregado da Informação a
            responder as consultas da [DTV/SKY] a este respeito.
          </p>
          <p>
            Com uma frequência razoável durante o termo em que seja estendido o
            Uso Autorizado e em lugar e tempo definidos de mútuo acordo, a
            [DTV/SKY] poderá reunir-se com o Encarregado da Informação a fim de
            procurar esclarecimentos relativos à implementação e manutenção do
            Programa de Segurança e das Normas relativas à Proteção de Dados e a
            todo procedimento de segurança, auditoria e controles aplicados de
            modo específico na gestão dos Dados.
          </p>
          <p>
            Com aviso prévio e escrito de vinte e quatro (24) horas após um
            Incidente ou, em sua falta, pelo menos uma vez por ano, o Fornecedor
            deverá prover a um especialista ou auditor em matéria de segurança
            selecionado pela [DTV/SKY] (doravante o “Auditor de Segurança”) o
            acesso a todas as instalações, sistemas e registros em poder do
            Fornecedor ou sob seu controle a fim de inspecionar o Uso dos Dados
            por parte do Fornecedor e o cumprimento do Programa de Segurança e
            as Normas relativas à Proteção de Dados.
          </p>
          <p>
            O Auditor de Segurança poderá (ou não) ser um empregado da [DTV/SKY]
            e, antes da realização das inspeções, deverá assinar um acordo de
            confidencialidade de caráter padrão aprovado em termos razoáveis
            pelo Fornecedor. Caso o Fornecedor mantenha instalações e sistemas
            compartilhados para vários clientes, o Auditor de Segurança deverá
            informar para a [DTV/SKY] unicamente os resultados de sua inspeção
            que sejam pertinentes ao uso dos Dados e os encontrados relativos ao
            cumprimento do Programa de Segurança e das Normas relativas à
            Proteção de Dados, abstendo-se de apresentar outra informação de
            caráter não público que seja unicamente de propriedade do Fornecedor
            ou de outros clientes do Fornecedor. Salvo em que as circunstâncias
            particulares do caso demandem o contrário, o Fornecedor poderá, de
            modo razoável permitir o acesso do Auditor de Segurança durante
            horários comerciais, ou fora do horário de trabalho a fim de
            minimizar as interrupções na operação normal da atividade comercial
            do Fornecedor.
          </p>
          {/* <h3>4. FUNCIONAMENTO DO SERVIÇO</h3> */}
          <h3>4. TITULARIDADE</h3>
          <p>
            O Fornecedor reconhece e aceita que a [DTV/SKY] possui de maneira
            absoluta e exclusiva: (a) os direitos de autor, direitos sui generis
            e demais direitos de propriedade e/ou titularidade sobre os Dados; e
            (b) os direitos de compilação e semelhantes relativos ao Uso
            Autorizado.
          </p>
          <p>
            A apropriação ou outro Uso não autorizado dos Dados por parte do
            Fornecedor ocasionará danos de difícil reparação ulterior à
            [DTV/SKY]. A [DTV/SKY] poderá solicitar às autoridades a emissão de
            medidas cautelares, ordens de restrição, ou exercitar qualquer outra
            ação para prevenir ou impedir o Uso não autorizado dos Dados, sua
            apropriação indevida ou risco à sua segurança.
          </p>
          <p>
            O Fornecedor cumpre o papel de custódio e fiduciário em benefício da
            [DTV/SKY], a respeito dos Dados que se encontram sob seu controle,
            salientando que não serão transferidos ao Fornecedor qualquer
            direito de propriedade ou titularidade sobre os Dados ou suas cópias
            (incluindo formatos físicos e eletrônicos dos mesmos). Os Dados em
            todos os seus formatos continuarão sendo propriedade exclusiva da
            [DTV/SKY], e não poderão ser objeto de confisco, penhora ou
            constrição por parte de qualquer credor do Fornecedor, e, ainda, o
            Fornecedor não poderá exercer direito de retenção sobre os Dados nem
            adotar qualquer ação que resulte inconsistente com o mencionado.
          </p>
          <p>
            A [DTV/SKY] poderá em qualquer instância, solicitar por escrito ao
            Fornecedor, com ou sem causa, a imediata suspensão do Uso dos Dados
            que se encontrem em poder do Fornecedor ou sob seu controle, ou sua
            imediata devolução e/ou eliminação em todos seus formatos (tanto
            eletrônicos quanto físicos).
          </p>
        </div>
      </Content>
    </Container>
  );
};

export default SegurancaInformacao;
